module.exports = __webpack_public_path__ + "img/debatePresi2019.98654a44.jpg";